module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vlymp3-28363048dfdd6d9246dae9106bf816dc.jpg";